@if (open()) {
<div class="fixed inset-0 z-40 bg-black/60 backdrop-blur-sm" (click)="onClose()"></div>
<div class="fixed inset-0 z-50 flex items-center justify-center p-2">
    <div class="bg-white rounded-2xl shadow-2xl w-[50vw] flex flex-col overflow-hidden"
        (click)="$event.stopPropagation()">
        <div class="flex justify-between border-b">
            <h1 class="p-3 fs-16 fw-600">{{'SYSMESER0021' | translate}}</h1>
            <button (click)="onClose()" class="p-3 fw-600">
                <i class="pi pi-times"></i>
            </button>
        </div>
        <hr>

        <div class="w-full p-2 flex flex-col justify-between gap-2 h-[70vh]">
            <div [innerHTML]="safeContentMap.get(notice.boarD_SEQ)" class="ql-editor">
            </div>
            <div class="grid grid-cols-3 gap-1 mt-2 bg-gray-100">
                <div class="w-full" *ngFor="let item of notice.files; let i = index">
                    <div class="item flex items-center gap-1 cursor-pointer border p-1 rounded" (click)="review(item)">
                        <ng-container [ngSwitch]="item.kind">

                            <!-- IMAGE -->
                            <img *ngSwitchCase="'image'" [src]="item.previewUrl" class="object-cover rounded h-7 w-7">

                            <!-- VIDEO -->
                            <video *ngSwitchCase="'video'" [src]="item.previewUrl" class="object-cover rounded h-7 w-7"
                                muted controls>
                            </video>

                            <!-- PDF -->
                            <i class="fs-26 pi pi-file-pdf" *ngSwitchCase="'pdf'"></i>

                            <!-- DOCX -->
                            <i class="fs-26 pi pi-file-word" *ngSwitchCase="'docx'"></i>

                            <!-- EXCEL -->
                            <i class="fs-26 pi pi-file-excel" *ngSwitchCase="'excel'"></i>

                            <!-- TEXT -->
                            <i class="fs-26 pi pi-file" *ngSwitchCase="'txt'"></i>

                            <!-- DEFAULT -->
                            <i class="fs-26 pi pi-file" *ngSwitchDefault></i>

                        </ng-container>

                        <div class="info flex-1 text-ellipsis">
                            <div class="text-ellipsis">
                                {{ cleanName(item.name) }}
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    </div>
</div>
}